import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule }    from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AppCommonPipesModule } from '../../app-common-pipes/app-common-pipes.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { GoogleMapsAddressCompleteComponent } from '../google-maps-address-complete/google-maps-address-complete.component';
import { ViewPersonComponent } from './view-person/view-person.component';
import { EditPersonComponent } from './edit-person/edit-person.component';
import { ListUserPeopleComponent } from './list-user-people/list-user-people.component';
import { SelectStateComponent } from './select-state/select-state.component';

import { AddPersonViewService } from './providers/add-person-view.service';
import { ModalChoosePersonComponent } from './modal-choose-person/modal-choose-person.component';
import { ModalUsefPersonSearchComponent } from './modal-usef-person-search/modal-usef-person-search.component';
import { ModalAddPersonComponent } from './modal-add-person/modal-add-person.component';
import { ListPayeesComponent } from './list-payees/list-payees.component';
import { ModalChoosePayeeComponent } from './modal-choose-payee/modal-choose-payee.component';
import { ModalEditPersonComponent } from './modal-edit-person/modal-edit-person.component';
import { MyPeopleComponent } from './my-people/my-people.component';
import { SelectCountryComponent } from './select-country/select-country.component';
import { ModalNsbaMemberSearchComponent } from './modal-nsba-member-search/modal-nsba-member-search.component';

@NgModule({
  imports: [
    CommonModule,
    NgbModule,
    FormsModule,
    FontAwesomeModule,
    AppCommonPipesModule,
    GoogleMapsAddressCompleteComponent
  ],
  providers: [ AddPersonViewService ],
  exports: [ ViewPersonComponent, EditPersonComponent, SelectStateComponent, SelectCountryComponent ],
  declarations: [ ViewPersonComponent, EditPersonComponent, ListUserPeopleComponent, SelectStateComponent, ModalChoosePersonComponent, ModalUsefPersonSearchComponent, ModalAddPersonComponent, ListPayeesComponent, ModalChoosePayeeComponent, ModalEditPersonComponent, MyPeopleComponent, SelectCountryComponent, ModalNsbaMemberSearchComponent ],
})
export class PeopleModule { }
